"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BasesV3Controller", {
    enumerable: true,
    get: function() {
        return BasesV3Controller;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
const _basesv3service = require("~/services/v3/bases-v3.service");
const _utils = require("~/utils");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
// decide scope based on whether it's EE or CE
const BASE_SCOPE = _utils.isEE ? 'workspace' : 'org';
let BasesV3Controller = class BasesV3Controller {
    // decide permission name based on whether it's EE or CE
    async list(context, queryParams, req, workspaceId) {
        const bases = await this.baseV3Service.baseList(context, {
            user: req.user,
            query: queryParams,
            workspaceId
        });
        return {
            list: bases
        };
    }
    async baseGet(context, baseId, qsInclude) {
        const base = await this.baseV3Service.getProjectWithInfo(context, {
            baseId: baseId,
            qsInclude,
            includeConfig: false
        });
        return base;
    }
    async baseUpdate(context, baseId, body, req) {
        const base = await this.baseV3Service.baseUpdate(context, {
            baseId,
            base: body,
            user: req.user,
            req
        });
        return base;
    }
    async baseDelete(context, baseId, req) {
        const deleted = await this.baseV3Service.baseSoftDelete(context, {
            baseId,
            user: req.user,
            req
        });
        return deleted;
    }
    async baseCreate(context, baseBody, req, workspaceId) {
        const base = await this.baseV3Service.baseCreate({
            base: baseBody,
            req,
            user: req['user'],
            workspaceId
        });
        return base;
    }
    constructor(baseV3Service){
        this.baseV3Service = baseV3Service;
    }
};
_ts_decorate([
    (0, _extractidsmiddleware.Acl)(_utils.isEE ? 'workspaceBaseList' : 'baseList', {
        scope: BASE_SCOPE
    }),
    (0, _common.Get)('/api/v3/meta/workspaces/:workspaceId/bases'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Query)()),
    _ts_param(2, (0, _common.Req)()),
    _ts_param(3, (0, _common.Param)('workspaceId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof Record === "undefined" ? Object : Record,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], BasesV3Controller.prototype, "list", null);
_ts_decorate([
    (0, _extractidsmiddleware.Acl)('baseGet'),
    (0, _common.Get)('/api/v3/meta/bases/:baseId'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Query)('include')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        Array
    ]),
    _ts_metadata("design:returntype", Promise)
], BasesV3Controller.prototype, "baseGet", null);
_ts_decorate([
    (0, _extractidsmiddleware.Acl)('baseUpdate'),
    (0, _common.Patch)('/api/v3/meta/bases/:baseId'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.BaseUpdateV3Type === "undefined" ? Object : _nocodbsdk.BaseUpdateV3Type,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], BasesV3Controller.prototype, "baseUpdate", null);
_ts_decorate([
    (0, _extractidsmiddleware.Acl)('baseDelete'),
    (0, _common.Delete)('/api/v3/meta/bases/:baseId'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], BasesV3Controller.prototype, "baseDelete", null);
_ts_decorate([
    (0, _extractidsmiddleware.Acl)('baseCreate', {
        scope: BASE_SCOPE
    }),
    (0, _common.HttpCode)(200),
    (0, _common.Post)('/api/v3/meta/workspaces/:workspaceId/bases'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Body)()),
    _ts_param(2, (0, _common.Req)()),
    _ts_param(3, (0, _common.Param)('workspaceId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _nocodbsdk.BaseCreateV3Type === "undefined" ? Object : _nocodbsdk.BaseCreateV3Type,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], BasesV3Controller.prototype, "baseCreate", null);
BasesV3Controller = _ts_decorate([
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    (0, _common.Controller)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _basesv3service.BasesV3Service === "undefined" ? Object : _basesv3service.BasesV3Service
    ])
], BasesV3Controller);
